export const OFFERS_COUNT_PLACEHOLDER = '{количество_предложений}';
export const ORGANIZATIONS_COUNT_PLACEHOLDER = '{количество_организаций_где}';
export const MIN_RATE_PLACEHOLDER = '{минимальная_ставка}';
export const YEAR_PLACEHOLDER = '{год}';
